export const Events={
    SWITCH_VARIANT: "SWITCH_VARIANT",
    ADD_VARIANT: "ADD_VARIANT",
    DELETE_VARIANT: "DELETE_VARIANT"
};


// WEBPACK FOOTER //
// ./src/editor/ui/editor/CollectionNavigation/Constants.ts